/** ***********
*
* <file-size-format.pipe.ts v1.0>
*
* Copyright (c) 2022 AIRBUS OPERATIONS
*
* Contributors:
*  GARY Adrien (NG635E8) [adrien.gary.external@airbus.com]
*
* All rights reserved.
**************/

import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'fileSizeFormat',
    standalone: false
})
export class FileSizeFormatPipe implements PipeTransform {

  transform(bytes: number, decimals?: number): string {
    if (bytes === 0) {
        return '0 Bytes';
    }
    const k = 1024;
    const dm = decimals <= 0 ? 0 : decimals || 2;
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return `${(bytes / Math.pow(k, i)).toFixed(dm).replace(/0$/g, '')} ${sizes[i]}`;
  }

}
